import { render, staticRenderFns } from "./PortcallRemainingDialog.vue?vue&type=template&id=bc539c24&"
import script from "./PortcallRemainingDialog.vue?vue&type=script&lang=ts&"
export * from "./PortcallRemainingDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports